export const EventBroadcastStyleKeys = {
  slim: 'slim',
  overlay: 'overlay',
}
